import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["source", "initialContent", "notice", "button"];
  static classes = ["hidden"];
  static values = { isIconOnly: Boolean };

  declare sourceTarget: HTMLInputElement;
  declare initialContentTarget: HTMLElement;
  declare noticeTarget: HTMLElement;
  declare buttonTarget: HTMLButtonElement;
  declare hiddenClass: string;
  declare isIconOnlyValue: boolean;

  async copy(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(this.sourceTarget.value);
      this.revealNotice();
      setTimeout(() => this.reset(), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  }

  private revealNotice() {
    if (this.isIconOnlyValue) {
      const noticeText = this.element.dataset.noticeText as string;
      this.buttonTarget.setAttribute("aria-label", noticeText);
      this.buttonTarget.setAttribute("data-title-tooltip", noticeText);
      this.toggleContent();
    } else {
      this.toggleContent();
    }
  }

  private reset() {
    if (this.isIconOnlyValue) {
      const text = this.element.dataset.text as string;
      this.buttonTarget.setAttribute("aria-label", text);
      this.buttonTarget.setAttribute("data-title-tooltip", text);
      this.toggleContent();
    } else {
      this.toggleContent();
    }
  }

  private toggleContent() {
    this.initialContentTarget.classList.toggle(this.hiddenClass);
    this.noticeTarget.classList.toggle(this.hiddenClass);
  }
}
